import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "../data/site";
import Logo from "./Logo";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#f7f4ec] border-b border-[#e3ddcf]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-[auto_1fr_auto] items-center h-24 md:h-28 gap-6">
          {/* Logo */}
          <Link
            to="/"
            data-testid="navbar-logo-link"
            className="flex items-center group"
            aria-label="Gateway Boat Co. — Home"
          >
            <Logo variant="inline-light" size="md" testId="navbar-logo" />
          </Link>

          {/* Desktop nav — centered */}
          <nav className="hidden lg:flex items-center justify-center gap-10" aria-label="Primary">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`navbar-link-${item.to.replace("/", "")}`}
                className={({ isActive }) =>
                  `nav-link relative py-2 ${isActive ? "active" : ""}`
                }
              >
                {({ isActive }) => (
                  <>
                    <span>{item.label}</span>
                    {isActive && (
                      <span className="absolute left-0 right-0 -bottom-0.5 h-[2px] bg-[#b8895a]" />
                    )}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/book"
            data-testid="navbar-book-now-button"
            className="btn-primary hidden lg:inline-flex justify-self-end"
          >
            Book Now
          </Link>

          {/* Mobile toggle */}
          <button
            type="button"
            data-testid="navbar-mobile-toggle"
            className="lg:hidden p-2 text-[#2b2b2b] justify-self-end col-start-3"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
          >
            {mobileOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          className="lg:hidden bg-[#f7f4ec] border-t border-[#e3ddcf]"
          data-testid="navbar-mobile-menu"
        >
          <nav className="flex flex-col px-6 py-6 gap-5" aria-label="Mobile">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`navbar-mobile-link-${item.to.replace("/", "")}`}
                className={({ isActive }) =>
                  `nav-link py-2 ${isActive ? "active" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              data-testid="navbar-mobile-book-now"
              className="btn-primary self-start mt-2"
            >
              Book Now
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
